import { connect } from 'react-redux';
import {
  loadReportData,
} from '../../../reducers/reports.reducers';
import Widget from './widget';

import { currencies } from '../../../models';

const mapStateToProps = (state, ownProps) => {
  const { reportWidgetID, reportDataId } = ownProps;
  const { reportData, loadingReports } = state.reports;

  const reportDataForThisWidget = reportData.filter(l => l.widgetId === reportWidgetID
      && ((reportDataId === undefined || reportDataId === null) || l.reportDataId === reportDataId))
    .map(l => l.reportData);
  const isLoading = loadingReports.some(r => r.widgetId === reportWidgetID);

  const currencySymbol = currencies[state.reports.selectedLocation.currency] || '€';

  return {
    reportData: reportDataForThisWidget,
    isLoading,
    currencySymbol,
    locationId: state.reports.selectedLocation.id,
    useDesktopLayout: state.app.useDesktopLayout,
    isMultiLocationReport: state.reports.selectedReport.isMultiLocationReport,
    locationIds: state.reports.locationIds,
  };
};

const mapDispatchToProps = dispatch => ({
  loadReportData: payload => dispatch(loadReportData(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Widget);
